export enum CopyrightType {
  Normal = "NORMAL",
  Form = "FORM",
}
